// One key per intended payment: made when the payment form opens, kept for a
// retry of that same submit, and dropped after a success, cancel or close.
export function newIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export const PAYMENT_UNCONFIRMED = "We couldn't confirm the payment was saved. Refresh the page to check before trying again.";
export const PAYMENT_REPLAYED = 'This payment was already recorded. No second payment was made.';
export const BILL_REPLAYED = 'This bill has already moved to its next due date. No second payment was recorded.';

// A 5xx or no response at all: the write may or may not have landed.
export function isPaymentUnconfirmed(error) {
  const status = error?.response?.status;
  return !status || status >= 500;
}
